import Model from "./base/model";

class Token extends Model {
  resourceName() {
    return "tokens";
  }

  fields() {
    return {
      // token_type: "",
      // expires_in: "",
      access_token:"",
      user: {},
      company: {},
      hash: "",
      onboarding: "",
    };
  }

  async login(payload){
    return this.request(
      "login",
      "POST",
      {},
      payload
    )
  }

  async forgotPassword(payload){
    return this.request(
      "forgot_password",
      "POST",
      {},
      payload
    )
  }

  async verifyEmail(data){
    return this.request(
      "verify_email",
      "POST",
      {},
      data
    )
  }

  async insertPassword(data){
    return this.request(
      "insert_password",
      "POST",
      {},
      data
    )
  }

}



export default new Token();
